import Chart from "react-apexcharts";
import React from "react";

const PieChart = ({ chartUtils, colors }) => {
  const options = {
    labels: chartUtils?.series.map((item) => item?.name),
    fill: {
      colors: colors || ["#008FFB", "#00E396", "#FEB019", "#FF4560"],
      type: "gradient",

      gradient: {
        shadeIntensity: 0.5,
        opacityFrom: 0.7,
        opacityTo: 0.8,
        stops: [0, 90, 100],
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val.toFixed(2) + "%";
      },
    },
  };

  const series = Array.isArray(chartUtils?.series)
  ? chartUtils.series.map((item) =>
      Array.isArray(item?.data) && item?.data.length > 0 ? item.data[0] : 0
    )
  : [];

  return (
    <Chart
      options={options}
      series={series}
      type="pie"
      height={350}
      width={"100%"}
    />
  );
};

export default PieChart;
